module.exports = __webpack_public_path__ + "img/logo-gia@2x.c7498ce.webp";